import { Text, View, Image } from "@react-pdf/renderer";
import { PDFList } from "./PDFList";
import { InitialPallets, Report } from "../../interfaces/intakes.reports"
// import { PDFListDefects } from "./PDFListDefects";
import { PDFPage } from "./PDFPage";
import { PDFPalletData } from "./PDFPalletData";
import { globalStyles } from "./DocuPdf";
import { useIsNewReport } from "../../hooks/useIsNewReport";
import { PDFListDefectsNew } from "./PDFListDefectsNew";
import { PDFImages } from "./PDFImages";
import { PDFWeather } from "./PDFWeather";
import { HTMLtoPDF } from "../customs/HTML-Text/HTMLtoPDF";

interface Props {
    pallet: InitialPallets
    index: number
    data: Report
    charts?: Record<string, string[]>
}
export const PDFPallets = ({ pallet, index, data, charts }: Props) => {

    const isNewReport = useIsNewReport(data?.date)

    return (
        <>
            <PDFPage data={data} wrap={false} index={index}>
                {
                    // Si es la primera página, muestra los comentarios generales y el clima antes de la cosecha
                    // index === 0 &&
                    // <View style={{ marginBottom: 10 }}>
                    //     <View style={[globalStyles.comments]}>
                    //         <Text style={[globalStyles.h2, {marginBottom: 10}]}>General Comments</Text>
                    //         {/* <HTMLtoPDF html={data.comments} /> */}
                    //         {data.comments ? <HTMLtoPDF html={data.comments} /> : null}
                    //     </View>

                    //     {
                    //     (data.weather && data.weather.length > 0) &&
                    //     data.weather.map((location, index) => (
                    //         <PDFWeather key={index} location={location}/>
                    //     ))
                    //     }
                    // </View>
                }

                <PDFPalletData index={index} pallet={pallet} date={data?.date || new Date()} isNewReport={isNewReport} />

                <View style={{ flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <View style={{ width: '46%' }}>
                        <PDFList pallet={pallet} detailName="labels" isNewReport={isNewReport} />
                        <View style={{ marginBottom: 15 }} />
                        <PDFList pallet={pallet} detailName={isNewReport ? "appearance" : "appareance"} isNewReport={isNewReport} />
                    </View>
                    <View style={{ width: '46%' }}>
                        {
                            (pallet.comments && pallet.comments.length > 0) &&
                            <View style={[globalStyles.comments, { marginBottom: 15 }]}>
                                <Text style={[globalStyles.h2]}>Pallet comments</Text>
                                <Text style={{ color: '#878787', fontSize: '8.5px', lineHeight: '1.4px' }}>{pallet.comments}</Text>
                            </View>
                        }

                        <PDFListDefectsNew pallet={pallet} data={data} />

                        {/* {
                            isNewReport
                                ? <PDFListDefectsNew pallet={pallet} data={data} />
                                : <PDFListDefects pallet={pallet} data={data} />
                        } */}

                        <View style={{ marginVertical: 10, flex: 1, width: '100%', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                            {
                                (pallet.pallgrow && charts && charts[pallet.pid]) &&
                                charts[pallet.pid][0] &&
                                <View style={{ alignItems: 'center', width: '50%' }}>
                                    <Image
                                        src={charts[pallet.pid][0]}
                                        style={{ width: '100%', height: 'auto', marginTop: 10 }}
                                    />
                                </View>
                            }
                            {
                                (pallet.pallgrow && charts && charts[pallet.pid]) &&
                                charts[pallet.pid][1] &&
                                <View style={{ alignItems: 'center', width: '50%' }}>
                                    <Image
                                        src={charts[pallet.pid][1]}
                                        style={{ width: '100%', height: 'auto', marginTop: 10 }}
                                    />
                                </View>
                            }
                        </View>

                    </View>
                </View>
            </PDFPage>

            {
                pallet.images.length > 0 &&
                <PDFPage data={data}>
                    <PDFImages images={pallet.images} />
                </PDFPage>

            }
        </>
    )
}